import styled from "styled-components";
import { Row } from "react-bootstrap";
const RowItem = styled(Row)`
  margin-right: ${(props) => (props.margin ? `${props.margin}` : "0px")};
  margin-left: ${(props) => (props.margin ? `${props.margin}` : "0px")};
`;

export default RowItem;
